module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af8bfc90dc5221c4f55825196b6c6776.png";